import { render, staticRenderFns } from "./studyList.vue?vue&type=template&id=6ad5a55e&scoped=true&"
import script from "./studyList.vue?vue&type=script&lang=js&"
export * from "./studyList.vue?vue&type=script&lang=js&"
import style0 from "./studyList.vue?vue&type=style&index=0&id=6ad5a55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5a55e",
  null
  
)

export default component.exports